import React from 'react';
import PageHeader from 'components/common/PageHeader';
import { Card } from 'react-bootstrap';

const Checks = () => {
  return (
    <>
      <PageHeader
        title="Проверки | Профиль"
        description="Тут будет страница проверок"
        className="mb-3"
      />
      <Card>
        <Card.Body>
          <p>Содержимое страницы</p>
        </Card.Body>
      </Card>
    </>
  );
};

export default Checks;
